import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncompleteFormComponent } from './incomplete-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrMaskerModule } from 'br-mask';

@NgModule({
  declarations: [IncompleteFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrMaskerModule
  ],
  exports: [
    IncompleteFormComponent
  ]
})
export class IncompleteFormModule { }
